import * as React from 'react'
import axios from 'axios'

// Keeps the profile's timezone equal to the browser's, so lifecycle emails
// can be sent at a sensible local hour. Once per browser session, for a
// signed-in user on their own pages: one read, and one write only when the
// stored value differs. Never surfaces a failure; the next session tries again.
const SESSION_KEY = 'profile.timezoneSynced.v1'

export function browserTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null
    } catch (error) {
        return null
    }
}

export async function syncTimezone({
    timezone = browserTimezone(),
    storage = typeof window !== 'undefined' ? window.sessionStorage : null,
} = {}) {
    if (!timezone) return 'no-timezone'
    try {
        if (storage && storage.getItem(SESSION_KEY) === timezone)
            return 'already-synced'
    } catch (error) {
        // Storage can be unavailable; a repeated read is the only cost.
    }
    const response = await axios.get('/me/profile')
    const profile = response.data && response.data.profile
    let outcome = 'unchanged'
    if (!profile || profile.timezone !== timezone) {
        await axios.patch('/me/profile', { timezone })
        outcome = 'updated'
    }
    try {
        if (storage) storage.setItem(SESSION_KEY, timezone)
    } catch (error) {
        // ignore
    }
    return outcome
}

export default function useTimezoneSync(enabled) {
    React.useEffect(() => {
        if (!enabled) return
        syncTimezone().catch(() => null)
    }, [enabled])
}
